module.exports = __webpack_public_path__ + "static/img/vn.6c04c2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/img/footer_icon/hover/vn.png
// module id = cj83
// module chunks = 0